import { Grid } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const cardHeightBreakpoints = { md: 350, sm: 692, xs: 752 }

export const OuterWrapper = styled('div')(({ theme }) => ({
  padding: '64px 24px 48px',
  margin: '0 -24px',
  overflowX: 'hidden',

  [theme.breakpoints.down('sm')]: {
    padding: '48px 16px',
    margin: '0 -16px',
  },
}))

export const Container = styled('div')(({ theme }) => ({
  minHeight: cardHeightBreakpoints.md,
  position: 'relative',

  [theme.breakpoints.down('sm')]: {
    minHeight: cardHeightBreakpoints.sm,
  },

  [theme.breakpoints.down('xs')]: {
    minHeight: cardHeightBreakpoints.xs,
  },
}))

export const SlideWrapper = styled('div')({
  position: 'absolute',
})

export const GridContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
  },
}))

export const ImagePreviewContainer = styled('div')({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  position: 'relative',
})

export const ImageWrap = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '278px',
  height: '68px',
})

export const PreviewImage = styled('img')({
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
})

export const Card = styled(Grid)(({ theme }) => ({
  boxShadow: '5px 10px 30px 0px rgba(18, 38, 109, 0.10)',
  backgroundColor: 'white',
  justifyContent: 'center',
  display: 'flex',
  height: cardHeightBreakpoints.md,

  [theme.breakpoints.down('sm')]: {
    minHeight: cardHeightBreakpoints.sm - 290,
  },
  [theme.breakpoints.down('xs')]: {
    minHeight: cardHeightBreakpoints.xs - 290,
  },
}))

export const CardContent = styled('div')(({ theme }) => ({
  padding: '48px 80px 20px',
  display: 'flex',
  flexDirection: 'column',

  [theme.breakpoints.down('sm')]: {
    padding: '28px 16px 32px',
  },
}))

export const LogoWrapper = styled('div')({
  marginBottom: '24px',
})

export const LinkWrapper = styled('div')(({ theme }) => ({
  paddingTop: '24px',
  '& .MuiLink-root': {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  '& .MuiLink-root:hover': {
    color: theme.colors.sky[900],
  },
}))

export const RadioWrapper = styled('div')({
  paddingTop: '8px',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'end',
  flexGrow: 1,
})

export const PreviewGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexBasis: 'unset',
    height: 290,
  },
}))
